import logoMark from '../../assets/logo.svg';
import { cx } from '../../lib/cx';

export interface BrandLogoProps {
  /** Hide the "mybusinessmate" wordmark and show only the mark. */
  markOnly?: boolean;
  className?: string;
}

/** Figma "Brand/Logo mark" + wordmark (Heading/H3). */
export function BrandLogo({ markOnly = false, className }: BrandLogoProps) {
  return (
    <span className={cx('inline-flex items-center gap-(--mbm-space-2)', className)}>
      <img src={logoMark} alt={markOnly ? 'mybusinessmate' : ''} className="size-(--mbm-icon-xl)" />
      {markOnly ? null : <span className="text-heading-h3 text-text-primary">mybusinessmate</span>}
    </span>
  );
}
